import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimePickerComponent } from './date-time-picker.component';
import { MonthComponent } from './month/month.component';
import { YearComponent } from './year/year.component';
import { DatePickerNoRangeComponent } from './datePicker-NoRange/datePicker-NoRange.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdatePipe } from './cdate.pipe';

import { TimerComponent } from './timer/timer.component';
import { DatePickerWithRangeComponent } from './datePicker-WithRange/datePicker-WithRange.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    DateTimePickerComponent,
    MonthComponent,
    YearComponent,
    DatePickerNoRangeComponent,
    DatePickerWithRangeComponent,
    TimerComponent,
    CdatePipe,
      
   ],
  exports:[
    MonthComponent,
    DateTimePickerComponent,
    YearComponent,
    DatePickerNoRangeComponent,
    DatePickerWithRangeComponent,
    TimerComponent,

],
providers:[]
})
export class DateTimePickerModule { }
